import { SITE } from "../siteConfig";

const PHRASES = ["Precision aerial mapping", ...SITE.areas, SITE.tagline];

export const Marquee = () => {
  const row = [...PHRASES, ...PHRASES, ...PHRASES];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-forest/10 bg-sage-soft py-5"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((p, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="font-serif text-xl italic text-forest/80 md:text-2xl">{p}</span>
                <span className="h-1.5 w-1.5 rounded-full bg-ochre" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
